import { useState, useEffect } from "react";
import { createAddress } from "../services/addressService";
import { getProvinces, getCities } from "../services/addressService";
import ProvinceSelect from "../components/AddressCard/ProvinceSelect";
import CitySelect from "../components/AddressCard/CitySelect";
import { X, MapPinPlus } from "lucide-react";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

export default function AddressModal({ form, setForm, onSave, onClose }) {
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [provinceId, setProvinceId] = useState(null);
  const [cityId, setCityId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    document.body.classList.add("modal-open");

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  const handleSave = () => {
    const newErrors = {};

    console.log(form.name);

    const name = form.name?.trim() || "";
    const lname = form.lname?.trim() || "";
    const mobile = form.mobile?.trim() || "";
    const address = form.address?.trim() || "";

    if (!name) newErrors.name = "نام الزامی است";
    if (!lname) newErrors.lname = "نام خانوادگی الزامی است";
    if (!mobile) newErrors.mobile = "شماره موبایل الزامی است";
    if (!address) newErrors.address = "آدرس الزامی است";

    if (!form.provinceId) newErrors.provinceId = "انتخاب استان الزامی است";
    if (!form.cityId) newErrors.cityId = "انتخاب شهر الزامی است";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      Object.keys(newErrors)
        .reverse()
        .forEach((field) => {
          toast.error(newErrors[field], {
            className: "my-toast-error",
            duration: 1000,
          });
        });
      return;
    }

    setLoading(true);

    createAddress(form)
      .then(() => {
        toast.success("آدرس با موفقیت ثبت شد", {
          duration: 4000,
        });

       


        setLoading(false);
        onSave();
        onClose();
      })
      .catch((response) => {
        setLoading(false);

        if (response?.status === 422) {
          const data = response.data;
          setErrors(data.errors);
          Object.keys(data.errors)
            .reverse()
            .forEach((field) => {
              const msg = data.errors[field];
              toast.error(<p>{msg}</p>, {
                className: "my-toast-error",
                duration: 2000,
              });
            });

          return;
        }
       console.log("response:",response);
        toast.error("خطا در ثبت آدرس");
      });
  };

  

  useEffect(() => {
    getProvinces().then((data) => {
      setProvinces(data);
    });
  }, []);

  useEffect(() => {
    if (provinceId) {
      getCities(provinceId).then((data) => {
        setCities(data);
      });
    } else {
      setCities([]);
    }
  }, [provinceId]);

  return (
    <div className="modal-overlay AddressModal ">
      {" "}
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">ثبت آدرس</h5>
            <span className="close" onClick={onClose}>
              <X size={24} color="#fcfcfc" strokeWidth={1.75} />
            </span>
          </div>
          <div className="modal-body">
            <div className="modal  input-layer">
              <form className="register-form" autoComplete="off">
                <div className="form-row">
                  <div className="form-group">
                    <input
                      id="name"
                      type="text"
                      placeholder=" "
                      value={form?.name || ""}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          name: e.target.value,
                        })
                      }
                      autoComplete="new-password"
                    />

                    <label htmlFor="name">نام</label>
                  </div>

                  <div className="form-group">
                    <input
                      id="lname"
                      type="text"
                      placeholder=" "
                      value={form?.lname || ""}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          lname: e.target.value,
                        })
                      }
                      autoComplete="new-password"
                    />

                    <label htmlFor="lname">نام خانوادگی</label>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      id="mobile"
                      type="text"
                      placeholder=" "
                      value={form?.mobile || ""}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          mobile: e.target.value,
                        })
                      }
                      autoComplete="new-password"
                    />
                    <label htmlFor="mobile">شماره موبایل</label>
                  </div>

                  <div className="form-group">
                    <input
                      id="postalCode"
                      type="text"
                      placeholder=" "
                      value={form?.postalCode || ""}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          postalCode: e.target.value,
                        })
                      }
                      autoComplete="new-password"
                    />
                    <label htmlFor="postalCode">کد پستی</label>
                  </div>
                </div>

                <div className="form-group">
                  <textarea
                    name=""
                    id="address"
                    placeholder=" "
                    onChange={(e) =>
                      setForm({
                        ...form,
                        address: e.target.value,
                      })
                    }
                    autoComplete="new-password"
                  ></textarea>

                  <label htmlFor="address">آدرس </label>
                </div>

                <div className="form-row">
                  <ProvinceSelect
                    provinces={provinces}
                    provinceId={provinceId}
                    setProvinceId={setProvinceId}
                    setCityId={setCityId}
                    form={form}
                    setForm={setForm}
                    errors={errors}
                  />

                  <CitySelect
                    cities={cities}
                    cityId={cityId}
                    setCityId={setCityId}
                    provinceId={provinceId}
                    form={form}
                    setForm={setForm}
                    errors={errors}
                  />
                </div>

                <div className="form-group-update">
                  <button
                    type="button"
                    onClick={handleSave}
                    disabled={loading}
                    className="w-full h-12 rounded-xl bg-green-600 text-white flex items-center justify-center gap-2"
                  >
                    <MapPinPlus size={24} color="#ffffff" strokeWidth={1.5} />
                    {loading ? (
                      <span className="loader"></span>
                    ) : (
                      <span>ثبت اطلاعات</span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
